'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Mail,
    Send,
    Users,
    Globe,
    Clock,
    FileText
} from 'lucide-react';

export function EmailSystemContent() {
    const t = useTranslations('emailSystem');

    const features = [
        {
            icon: Mail,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Send,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: Users,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: Globe,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: Clock,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: FileText,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    const benefits = t.raw('benefits.list') as string[];

    return (
        <FeatureDetailContent
            pageKey="e-mail-system"
            translationNamespace="emailSystem"
            features={features}
            benefits={benefits}
            ctaIcon={Mail}
            showWhatIsBitcoin={true}
            introImageSrc="/images/features/E-mail-system.webp"
            introImageAlt={t('intro.imageAlt') || 'E-mail System Integration in MLM Software'}
            introParagraphKeys={['paragraph1', 'paragraph2']}
            introSectionHeadingPage="e-mail-system"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About E-mail System Integration'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'E-mail System Integration'}
        />
    );
}

